/**
 * An album's photos and the viewer's own videos in one list (VIDEO_PLAN V5).
 *
 * The album details route sends `photos` in display_order and, for their
 * uploader only, `videos` with the display_order they share with
 * album_photos (migration 299). Each clip goes in before the first photo the
 * author placed after it; the photos keep exactly the order they came in. (A
 * list with the cover pinned first — getAlbumById's — would pull earlier
 * clips ahead of it: merge only display-ordered photos.) A clip is marked
 * `media_type: 'video'`
 * (videoUploadService._tripVideoItem); photo-only actions check that.
 */

export const isAlbumVideo = (item) => item?.media_type === 'video';

export function mergeAlbumMedia(photos, videos) {
  const list = Array.isArray(photos) ? [...photos] : [];
  const clips = (Array.isArray(videos) ? videos : [])
    .filter(Boolean)
    .slice()
    .sort((a, b) => (a.display_order ?? Infinity) - (b.display_order ?? Infinity));
  for (const clip of clips) {
    const order = clip.display_order ?? Infinity;
    const at = list.findIndex(item => !isAlbumVideo(item) && (item.display_order ?? -Infinity) > order);
    if (at === -1) list.push(clip);
    else list.splice(at, 0, clip);
  }
  return list;
}

/** { photos, videos } counts for the header ("24 photos · 3 videos"). */
export function albumMediaCounts(items) {
  const videos = (items || []).filter(isAlbumVideo).length;
  return { photos: (items || []).length - videos, videos };
}
